import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=43a5967e&"
import script from "./Coverage.vue?vue&type=script&lang=ts&"
export * from "./Coverage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports